module.exports = __webpack_public_path__ + "media/images/loyalty_stamp-9dba86bd15333ab6b80873650297031b.png";